import axios from "axios"
import * as actions from "../actions/client"

export function addClient(client) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.post(process.env.REACT_APP_API_HOST + "/api/client/", client)
        .then(response => {
          if (response.data.Success) {
            dispatch(actions.addClientToLobbyist(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function getClientsForLobbyists(lobbyistId) {
  return (dispatch) => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/client?lobbyistId=" + lobbyistId)
      .then((response) => {
        let lobbyistClients = response.data ? response.data.$values : []
        dispatch(actions.getClientsForLobbyist(lobbyistClients))
      })
  }
}

export function getClient(clientId) {
  return (dispatch) => {
    return axios.get(process.env.REACT_APP_API_HOST + "/api/client/" + clientId)
      .then(response => dispatch(actions.getClient(response.data)))
  }
}

export function updateClient(client) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(process.env.REACT_APP_API_HOST + "/api/client/", client)
        .then(response => {
          if (response.data.Success) {
            dispatch(actions.updateClientForLobbyist(response.data.SuccessOutput))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function deleteClient(clientId) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.delete(process.env.REACT_APP_API_HOST + "/api/client/" + clientId)
        .then(response => {
          if (response.data.Success) {
            dispatch(actions.removeClientFromLobbyist(clientId))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}

export function clearClient() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.clearClient())
      resolve()
    })
  }
}

export function clearClientsFromLobbyist() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.clearClientsFromLobbyist())
      resolve()
    })
  }
}



// WEBPACK FOOTER //
// ./src/actionCreators/client.js